var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('Cfile'),_c('Function')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }